const AboutPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">About New Friends Colony RWA</h1>
      <div className="prose prose-lg text-gray-600">
        <p>Welcome to New Friends Colony RWA - your comprehensive complaint management system.</p>
        <p>We are committed to providing excellent service and maintaining the highest standards in our community.</p>
      </div>
    </div>
  )
}

export default AboutPage
